"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var WeekDays_1 = require("../../periodInWeek/WeekDays");
var getStrPeriodInWeek = function (intervals) {
    var _a, _b;
    var str = '';
    //сортируем
    intervals.sort(function (a, b) { return a.weekdays[0] - b.weekdays[0]; });
    var intervalsByDay = [];
    var _loop_1 = function (interval) {
        var _loop_2 = function (weekday) {
            if (!intervalsByDay.find(function (i) {
                return i.timeFrom === interval.timeFrom &&
                    i.timeTo === interval.timeTo &&
                    i.weekdays[0] === weekday;
            })) {
                intervalsByDay.push({
                    timeFrom: interval.timeFrom,
                    timeTo: interval.timeTo,
                    weekdays: [weekday],
                });
            }
        };
        for (var _i = 0, _a = interval.weekdays; _i < _a.length; _i++) {
            var weekday = _a[_i];
            _loop_2(weekday);
        }
    };
    // Разбиваем на интервалы с одним днем недели
    for (var _i = 0, intervals_1 = intervals; _i < intervals_1.length; _i++) {
        var interval = intervals_1[_i];
        _loop_1(interval);
    }
    var intervalsByDayResult = __spreadArrays(intervalsByDay);
    for (var i = 0; i < intervalsByDay.length; i++) {
        if (intervalsByDay[i].timeTo === '24:00:00') {
            for (var j = 0; j < intervalsByDay.length; j++) {
                if (j != i &&
                    intervalsByDay[j].timeFrom === '00:00:00' &&
                    intervalsByDay[j].timeTo !== '24:00:00' &&
                    intervalsByDay[j].timeTo < intervalsByDay[i].timeFrom &&
                    intervalsByDay[j].weekdays[0] === (intervalsByDay[i].weekdays[0] % 7) + 1) {
                    // Удаляем вторую половину, после 24:00
                    for (var k = 0; k < intervalsByDayResult.length; k++) {
                        if (intervalsByDayResult[k].timeFrom === intervalsByDay[j].timeFrom &&
                            intervalsByDayResult[k].timeTo === intervalsByDay[j].timeTo &&
                            intervalsByDayResult[k].weekdays[0] === intervalsByDay[j].weekdays[0]) {
                            intervalsByDayResult.splice(k, 1);
                            break;
                        }
                    }
                    // Обновляем дату конца у интервала, перешедшего за 24:00
                    for (var k = 0; k < intervalsByDayResult.length; k++) {
                        if (intervalsByDayResult[k].timeFrom === intervalsByDay[i].timeFrom &&
                            intervalsByDayResult[k].timeTo === intervalsByDay[i].timeTo &&
                            intervalsByDayResult[k].weekdays[0] === intervalsByDay[i].weekdays[0]) {
                            intervalsByDayResult[k].timeTo = intervalsByDay[j].timeTo;
                            break;
                        }
                    }
                }
            }
        }
    }
    intervalsByDayResult.sort(function (a, b) { return a.weekdays[0] - b.weekdays[0]; });
    // Объединяем одинаковые интервалы в разных днях недели в один
    var intervalsResult = [];
    for (var _c = 0, intervalsByDayResult_1 = intervalsByDayResult; _c < intervalsByDayResult_1.length; _c++) {
        var interval = intervalsByDayResult_1[_c];
        var isExists = false;
        for (var i = 0; i < intervalsResult.length; i++) {
            if (intervalsResult[i].timeFrom === interval.timeFrom &&
                intervalsResult[i].timeTo === interval.timeTo) {
                if (!intervalsResult[i].weekdays.includes(interval.weekdays[0])) {
                    intervalsResult[i].weekdays.push(interval.weekdays[0]);
                }
                isExists = true;
                break;
            }
        }
        if (!isExists) {
            intervalsResult.push(interval);
        }
    }
    intervals = intervalsResult;
    intervals.sort(function (a, b) { return a.weekdays[0] - b.weekdays[0]; });
    //собираем строку по периодам
    for (var i = 0; i < intervals.length; i++) {
        var weekdays = intervals[i].weekdays;
        var weekStr = '';
        //собираем строку по неделям
        if (weekdays.length === 7) {
            weekStr = 'Ежедневно';
        }
        else {
            for (var j = 0; j < weekdays.length; j++) {
                if (!weekStr) {
                    weekStr += WeekDays_1.WeekDays[weekdays[j]];
                }
                else {
                    if (weekdays[j - 1] === weekdays[j] - 1) {
                        if (weekStr.substr(weekStr.length - 1) === '-') {
                            if (j === weekdays.length - 1) {
                                weekStr += WeekDays_1.WeekDays[weekdays[j]];
                            }
                            else if (j === weekdays.length - 1 || weekdays[j] !== weekdays[j + 1] - 1) {
                                weekStr += WeekDays_1.WeekDays[weekdays[j]];
                            }
                        }
                        else {
                            weekStr += '-';
                            if (j === weekdays.length - 1 || weekdays[j] !== weekdays[j + 1] - 1) {
                                weekStr += WeekDays_1.WeekDays[weekdays[j]];
                            }
                        }
                    }
                    else {
                        weekStr += ', ' + WeekDays_1.WeekDays[weekdays[j]];
                    }
                }
            }
        }
        var time = '';
        var timeFrom = (_a = intervals[i].timeFrom) === null || _a === void 0 ? void 0 : _a.substr(0, 5);
        var timeTo = (_b = intervals[i].timeTo) === null || _b === void 0 ? void 0 : _b.substr(0, 5);
        if (timeFrom === '00:00' && timeTo === '24:00') {
            time = 'круглосуточно';
        }
        else {
            time = timeFrom + '-' + timeTo;
        }
        str += weekStr + ' ' + time + (i < intervals.length - 1 ? '; ' : '');
        weekStr = '';
    }
    return str;
};
exports.getStrPeriodInWeek = getStrPeriodInWeek;
//# sourceMappingURL=index.js.map